import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const LOGIN_FORM_FIELD_NAME_USERNAME = 'username'

export const LOGIN_FORM_FIELD_NAME_PASSWORD = 'password'

export const LOGIN_FORM_INITIAL_VALUES = {
  [LOGIN_FORM_FIELD_NAME_PASSWORD]: FORMIK_EMPTY_VALUE,
  [LOGIN_FORM_FIELD_NAME_USERNAME]: FORMIK_EMPTY_VALUE,
}

export const LOGIN_FORM_TYPE_EMAIL = 'email'

export const LOGIN_FORM_TYPE_PHONE = 'phone'

export const LOGIN_FORM_USERNAME_MAX_LENGTH = 255

export const LOGIN_FORM_PASSWORD_MAX_LENGTH = 128
